module.exports = __webpack_public_path__ + "static/media/colorbook-app.a5c17131.png";